import React from "react";
import logo from './spotify-logo.png';
import '../App.css';



const Navbar = () => {
  return (
    <nav className='header'>
     
      {/* <img className="logo" src= {logo} alt="" /> */}
      <h1>Spotify Analytics</h1>
      <h4 color="white">Free hosting please allow 30-60 seconds for data</h4>
      
    
    </nav>
  );



















}



export default Navbar;